import { TradeTypes } from "./globals.service";
import * as i0 from "@angular/core";
import * as i1 from "./globals.service";
export class PopupService {
    constructor(tradeTypes) {
        this.tradeTypes = tradeTypes;
        this.specialPopups = [];
        this.standardPopupOpen = false;
        this.standardPopTitle = "";
        this.standardPopContent = "";
        this.standardPopupButtons = [];
        this.specialPopups.length = 0;
        Object.keys(SpecialPopupType)
            .filter((k) => typeof SpecialPopupType[k] === "number")
            .forEach((type) => {
            this.specialPopups.push(new SpecialPopup(SpecialPopupType[type]));
        });
    }
    open(title, content, buttons = null) {
        this.standardPopTitle = title;
        this.standardPopContent = content;
        if (buttons == null) {
            this.standardPopupButtons.push(new PopupButton("Close", "", () => {
                this.close();
            }));
        }
        else {
            this.standardPopupButtons = buttons;
        }
        this.standardPopupOpen = true;
    }
    close() {
        this.standardPopTitle = "";
        this.standardPopContent = "";
        this.standardPopupButtons.length = 0;
        this.standardPopupOpen = false;
    }
    getSpecialPopup(type) {
        var ret = null;
        this.specialPopups.forEach((p) => {
            if (p.type == type) {
                ret = p;
            }
        });
        return ret;
    }
    openRedirectPopup(redirectPopupType, redirectURL) {
        var p = this.getSpecialPopup(SpecialPopupType.ConfirmRedirectToExternalURL);
        if (p != null)
            p.open = true;
        p.redirectURL = redirectURL;
        p.redirectMessage = this.getExternalRedirectMessage(redirectPopupType);
    }
    getExternalRedirectMessage(redirectPopupType) {
        switch (redirectPopupType) {
            case ExternalRedirectPopupType.RedirectToMovingService:
                return `You are being redirected to Smart Express website. Please read their privacy policy before submitting your personal data.`;
            case ExternalRedirectPopupType.RedirectToHRV:
                return `You are being redirected to the HRV website. Please read their privacy policy before submitting your personal data.`;
            case ExternalRedirectPopupType.RedirectToChemDryService:
                return `You are being redirected to Chem Dry website. Please read their privacy policy before submitting your personal data.`;
            default:
                return `You are being redirected to a third party website. Please read their privacy policy before submitting your personal data.`;
        }
    }
    openSpecialPopup(type, redirectURL = "", tradeTypeID = null) {
        var p = this.getSpecialPopup(type);
        if (p != null)
            p.open = true;
        if (redirectURL)
            p.redirectURL = redirectURL;
        if (tradeTypeID)
            p.tradeTypeID = tradeTypeID;
    }
    triggerExternalRedirect(popupType) {
        var p = this.getSpecialPopup(popupType);
        if (p && p.redirectURL)
            window.open(p.redirectURL);
    }
    closeSpecialPopup(type) {
        var p = this.getSpecialPopup(type);
        if (p != null) {
            p.open = false;
        }
    }
    getHTMLContentForTradeTypeInformationPopup() {
        var p = this.getSpecialPopup(SpecialPopupType.TradeTypeInformation);
        const tradeTypeID = p.tradeTypeID;
        var popupContent = new TradeTypeInformationPopupContent("UNKNOWN TRADE TYPE", "No additional information has been loaded for this trade type. Sorry about that :(", []);
        switch (tradeTypeID) {
            case this.tradeTypes.Plumbing:
                popupContent = new TradeTypeInformationPopupContent("Plumbing - Information", "Some of our plumbing installation and repair services include:", [
                    "Dishwasher installation",
                    "Toilet installation",
                    "Vanity installation",
                    "General plumbing maintenance",
                ]);
                break;
            case this.tradeTypes.Electrical:
                popupContent = new TradeTypeInformationPopupContent("Electrical - Information", "Some of our electrical installation services include:", [
                    "Oven installation",
                    "Installing new lighting - including LED upgrades, dimmers, and security lighting",
                    "Power point installations",
                    "Installing extractor fan",
                    "Switchboard upgrades, including RCD protection",
                ]);
                break;
            case this.tradeTypes.HVAC:
                popupContent = new TradeTypeInformationPopupContent("Air Con / Heat Pump - Information", "Our air con / heat pump services include:", ["Installation", "Maintenance / Cleaning", "Repair services"]);
                break;
            case this.tradeTypes.GutterCleaning:
                popupContent = new TradeTypeInformationPopupContent("Gutter Cleaning - Information", "todo", []);
                break;
            case this.tradeTypes.Locksmith:
                popupContent = new TradeTypeInformationPopupContent("Locksmith - Information", "Some of our locksmith services include:", [
                    "Lock-picking and unlocking services",
                    "Extracting broken keys",
                    "Re-keying and key duplication",
                    "Installing window locks or deadlocks",
                ]);
                break;
            case this.tradeTypes.Handyman:
                popupContent = new TradeTypeInformationPopupContent("Handyperson - Information", "Some of our handyperson services include:", [
                    "Repairing or replacing damaged drywall",
                    "Patching and painting walls",
                    "Staining and varnishing surfaces",
                    "Installing hooks, window latches, or locks",
                    "Installing towel rails",
                    "Miscellaneous jobs",
                ]);
                break;
            case this.tradeTypes.AAHealthyHomeInspection:
                popupContent = new TradeTypeInformationPopupContent("Home Inspections - Information", "Our home inspection services include:", [
                    "Healthy Home Inspections",
                    "Pre-Purchase/Sale Building Inspections",
                    "Rental Property Inspections",
                    "Methamphetamine Testing",
                    "Asbestos Testing",
                ]);
                break;
            case this.tradeTypes.AAFlatPackAssembly:
                popupContent = new TradeTypeInformationPopupContent("Flatpack Assembly - Information", "Some of our assembly services include:", [
                    "Barbecues",
                    "Garden sheds",
                    "Trampolines",
                    "Greenhouses",
                    "Outdoor and indoor furniture",
                    "Fitness equipment",
                ]);
                break;
            case this.tradeTypes.MovingService:
                popupContent = new TradeTypeInformationPopupContent("Moving In/Out - Information", "Our moving in/out services include:", [
                    "House and apartment moves",
                    "Intercity moves",
                    "Supply of packing materials",
                    "Office moves",
                ]);
                break;
            case this.tradeTypes.CarpetCleaningService:
                popupContent = new TradeTypeInformationPopupContent("Carpet Cleaning - Information", "Our carpet cleaning services include:", [
                    'Carpet Cleaning',
                    'Specialty Stain Removal',
                    'Specialty Rug Cleaning',
                    'Sanitise, Deodorise and Protect',
                    'Pet Urine and Odour Removal',
                    'Leather Cleaning',
                    'Upholstery Cleaning',
                    'Tile and Grout Cleaning',
                    'Mould Removal and Remediation',
                    'Trauma and Biohazard Cleaning',
                    'Flood and Water Restoration',
                    'Fire and Smoke Restoration',
                ]);
                break;
            default:
                break;
        }
        return popupContent;
    }
}
PopupService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PopupService_Factory() { return new PopupService(i0.ɵɵinject(i1.TradeTypes)); }, token: PopupService, providedIn: "root" });
export class TradeTypeInformationPopupContent {
    constructor(title, bodyContent, jobTypeNames) {
        this.title = "";
        this.bodyContent = "";
        this.jobTypeNames = [];
        this.title = title;
        this.bodyContent = bodyContent;
        this.jobTypeNames = jobTypeNames;
    }
}
export class PopupButton {
    constructor(text, classes, callback = null, replaceClasses = false) {
        this.text = "";
        this.classes = "standardButton buttonPointer";
        this.callback = null;
        this.text = text;
        this.classes = replaceClasses == true ? classes : this.classes + classes;
        this.callback = callback;
    }
    onClick() {
        if (this.callback != null) {
            this.callback();
        }
    }
}
export class SpecialPopup {
    constructor(type) {
        this.open = false;
        this.tradeTypeID = null; // for info popup
        // for SpecialPopupType.ConfirmRedirectToExternalURL
        this.redirectURL = ``;
        this.redirectMessage = ``;
        this.type = type;
    }
}
export var SpecialPopupType;
(function (SpecialPopupType) {
    SpecialPopupType[SpecialPopupType["Unknown"] = -1] = "Unknown";
    SpecialPopupType[SpecialPopupType["TermsAndConditions"] = 0] = "TermsAndConditions";
    SpecialPopupType[SpecialPopupType["PrivacyPolicy"] = 1] = "PrivacyPolicy";
    SpecialPopupType[SpecialPopupType["FAQ"] = 2] = "FAQ";
    SpecialPopupType[SpecialPopupType["ContactUs"] = 3] = "ContactUs";
    SpecialPopupType[SpecialPopupType["ConfirmRedirectToExternalURL"] = 4] = "ConfirmRedirectToExternalURL";
    SpecialPopupType[SpecialPopupType["TradeTypeInformation"] = 5] = "TradeTypeInformation";
})(SpecialPopupType || (SpecialPopupType = {}));
export var ExternalRedirectPopupType;
(function (ExternalRedirectPopupType) {
    ExternalRedirectPopupType[ExternalRedirectPopupType["RedirectGeneric"] = 1] = "RedirectGeneric";
    ExternalRedirectPopupType[ExternalRedirectPopupType["RedirectToHRV"] = 2] = "RedirectToHRV";
    ExternalRedirectPopupType[ExternalRedirectPopupType["RedirectToMovingService"] = 3] = "RedirectToMovingService";
    ExternalRedirectPopupType[ExternalRedirectPopupType["RedirectToChemDryService"] = 4] = "RedirectToChemDryService";
})(ExternalRedirectPopupType || (ExternalRedirectPopupType = {}));
